import { useAutumnSubscription } from "@/hooks/useAutumnSubscription";
import { Clock, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export function TrialStatusBanner() {
  const { isInTrial, getDaysRemaining, getTrialStatus } = useAutumnSubscription();
  
  if (!isInTrial()) {
    return null;
  }

  const daysRemaining = getDaysRemaining();
  const trialStatus = getTrialStatus();
  
  // Show warning when trial is ending soon (1 day or less)
  const isTrialEndingSoon = daysRemaining <= 1;
  
  return (
    <div className={`w-full p-4 border-b ${
      isTrialEndingSoon 
        ? 'bg-amber-50 border-amber-200' 
        : 'bg-emerald-50 border-emerald-200'
    }`}>
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          {isTrialEndingSoon ? (
            <AlertTriangle className="w-5 h-5 text-amber-600" />
          ) : (
            <Clock className="w-5 h-5 text-emerald-600" />
          )}
          <div>
            <p className={`font-medium ${
              isTrialEndingSoon ? 'text-amber-800' : 'text-emerald-800'
            }`}>
              {isTrialEndingSoon 
                ? 'Trial ending soon!' 
                : 'Free trial active'
              }
            </p>
            <p className={`text-sm ${
              isTrialEndingSoon ? 'text-amber-700' : 'text-emerald-700'
            }`}>
              {daysRemaining === 0 
                ? 'Your trial ends today' 
                : `${daysRemaining} day${daysRemaining !== 1 ? 's' : ''} remaining in your free trial`
              }
            </p>
          </div>
        </div>
        
        <div className="flex items-center gap-3">
          <Button 
            asChild
            variant={isTrialEndingSoon ? "destructive" : "default"}
            size="sm"
          >
            <Link to="/subscription">
              {isTrialEndingSoon ? 'Upgrade Now' : 'Get Lifetime Access'}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
} 